'use client';

import { PropsWithChildren, useState } from 'react';
import { GiftcardContextProvider } from 'context/giftcard';
import { getGiftcardById } from 'services/client/repositories/giftcard';
import { GiftcardRedeemPincodeForm } from './GiftcardRedeemPincodeForm';

interface Props extends PropsWithChildren {
  giftcardId: string;
  redeemToken: string;
  content: GiftcardRedeemPincodeContent;
}

export type GiftcardRedeemPincodeProps = Props;

export const GiftcardRedeemPincode = (props: Props) => {
  const { giftcardId, redeemToken, content, children } = props;

  const [isPincodePending, setIsPincodePending] = useState(true);
  const [giftcard, setGiftcard] = useState<AdaptedGiftcard | null>(null);

  const onPincodeSubmit = async () => {
    const _giftcard = await getGiftcardById({ giftcardId, redeemToken });

    setIsPincodePending(false);
    setGiftcard(_giftcard);
  };

  if (!isPincodePending && giftcard) {
    return (
      <GiftcardContextProvider giftcard={giftcard}>
        {children}
      </GiftcardContextProvider>
    );
  }

  return (
    <GiftcardRedeemPincodeForm
      content={content}
      onPincodeSubmit={onPincodeSubmit}
      giftcardId={giftcardId}
      redeemToken={redeemToken}
    />
  );
};
